export interface BindOutsideClickOptions {
  ignore?: Array<HTMLElement | null | undefined>;
}

export function bindOutsideClick(
  panel: HTMLElement,
  onOutside: (event: PointerEvent) => void,
  options: BindOutsideClickOptions = {},
): () => void {
  const handler = (event: PointerEvent) => {
    const target = event.target;
    if (!(target instanceof Node)) return;
    if (panel.contains(target)) return;
    for (const ignored of options.ignore ?? []) {
      if (ignored && ignored.contains(target)) return;
    }
    onOutside(event);
  };

  document.addEventListener("pointerdown", handler);
  return () => document.removeEventListener("pointerdown", handler);
}
